<template>
    <div class="ticket-info-container">
        <mobile-card :showFooter="showFooter">
            <template v-slot:title>
                <div>开票信息</div>
            </template>
            <template v-slot:content>
                <div class="flex-form-info">
                    <van-radio-group v-model="ticketType" icon-size="0.43rem" direction="horizontal"
                                     @change="handleTicketTypeChange">
                        <van-radio name="1" checked-color="#005423">个人</van-radio>
                        <van-radio name="2" checked-color="#005423" v-if="enableUseCompanyTitle">机构</van-radio>
                    </van-radio-group>
                </div>

                <van-field v-if="showPerson"
                           v-model="detail.userName"
                           clearable
                           label="名称"
                           label-align="left"
                           placeholder="请输入名称"
                           required
                ></van-field>

                <div v-if="showCompany" style="border-bottom: 1px solid #ebedf0;">
                    <div class="flex-form-info">
                        <span>名称：</span>
                        <span>{{detail.name}}</span>
                    </div>
                    <div class="flex-form-info">

                        <span>税号：</span>
                        <span>{{detail.taxNumber}}</span>
                    </div>
                    <div class="flex-form-info" v-if="!showDetail">
                        <span class="link" style="display:block;font-size: 12px;"
                              @click.prevent="showDetail=true">查看明细</span>
                    </div>
                    <div class="flex-form-info" v-if="showDetail">
                        <span>单位地址：</span>
                        <span>{{detail.address}}</span>
                    </div>
                    <div class="flex-form-info" v-if="showDetail">
                        <span>电话号码：</span>
                        <span>{{detail.tele}}</span>
                    </div>
                    <div class="flex-form-info" v-if="showDetail">
                        <span>开户银行：</span>
                        <span>{{detail.depositBank}}</span>
                    </div>
                    <div class="flex-form-info" v-if="showDetail">
                        <span>银行账户：</span>
                        <span>{{detail.bank}}</span>
                    </div>
                    <div class="flex-form-info" v-if="showDetail">
                    <span class="link" style="display:block;font-size: 12px;"
                          @click.prevent="showDetail=false">收起明细</span>
                    </div>
                </div>

                <div class="flex-form-info" style="margin-top:10px;" v-if="!showRemark">
                    <div class="left link" style="line-height: 28px;" @click.prevent="showRemark=!showRemark">填写票据备注
                    </div>
                </div>
                <div class="flex-form-info" v-if="showRemark">
                    <div class="left link" style="line-height: 28px;" @click.prevent="showRemark=!showRemark">收起票据备注：
                    </div>
                </div>
                <div class="flex-form-info" style="height: auto" v-if="showRemark">
                    <div style="width:100%;">
                        <van-field input-align="left" label-align="right" size="14px"
                                   class="text-field"
                                   style="padding: 0px; margin: 0px; padding-right: 5px; text-align:right"
                                   v-model="remark"
                                   rows="2"
                                   autosize
                                   type="textarea"
                                   :maxlength="remarkLimit"
                                   show-word-limit
                                   placeholder="请填入票据备注"
                        />
                    </div>
                </div>

            </template>

            <template v-slot:footer>
                <div class="flex-form-footer">
                    <mobile-button color="#005423" class="btn-font" @click="search">
                        <van-icon name="search"/>
                        <span>查找</span>
                    </mobile-button>
                    <mobile-button color="#005423" class="btn-font" @click="addNew">
                        <van-icon name="plus"/>
                        <span>新增</span>
                    </mobile-button>
                </div>
            </template>
        </mobile-card>

    </div>
</template>
<script>
    import mobileCard from "@/components/mobile-card/index"
    import MobileButton from "components/mobile-button/index"
    import {loadUserInfo} from '@/utils/cache'

    export default {
        name: "ticketInfo",
        props: {
            detail: Object,
            remarkLimit: Number
        },
        components: {
            MobileButton,
            mobileCard,
        },

        computed: {

            showFooter() {
                return this.ticketType === "2"
            },
        },
        data() {
            return {
                enableUseCompanyTitle: false,
                ticketType: "1",
                organ: {},
                showRemark: false,
                remark: '',
                showPerson: true,
                showCompany: false,
                showDetail: false,
                //detail:{},
            }
        },

        methods: {
            addNew() {
                this.$emit('add-organ')
            },

            search() {
                this.$emit('search-organ')
            },

            getTicketTitleAndTaxNum() {
                let title = ''
                if (this.ticketType === "1") {
                    title = this.detail.userName
                } else if (this.ticketType === "2") {
                    title = this.detail.name
                } else {
                    title = ""
                }
                return {
                    title: title,
                    taxNumber: this.detail.taxNumber,
                    depositBank: this.detail.depositBank,
                    tele: this.detail.tele,
                    bank: this.detail.bank,
                    address: this.detail.address,
                    remark: this.remark,
                }
            },

            handleTicketTypeChange(val) {
                console.log('val------', val)
                if (val == "1") {
                    this.showPerson = true;
                    this.showCompany = false;
                } else if (val == "2") {
                    this.showPerson = false;
                    this.showCompany = true;
                } else {
                    this.showPerson = true;
                    this.showCompany = false;
                }
                this.$emit('change-type', val)
            },

            updateTicketInfo(detail,enableUseCompanyTitle){
                this.enableUseCompanyTitle = enableUseCompanyTitle
                this.detail=detail
                this.ticketType=detail.ticketType
            }
        },
    }
</script>
<style lang="scss" scoped>
</style>
